import { fExecuteAPI } from "../../Server/Apis";
import {
  inv02_fINV02_Attributes_GETROW,
  inv02_fINV02_fDisplay_GETROW,
  inv02_INV02_LoadDetail_GETROW,
  WMSIInbound_WMINV03RSPMSPDetail_API,
  WmsInbound_getPendingPo_API,
  WmsInbound_getPallet_API,
  GRNNormal_Inv03CgetRow_GETROW,
  GRNNormal_deleteInv03CRow_GETROW,
  GRNNormal_updateInv03CRow_GETROW,
  GRNNormal_INV03D_GetRow_GETROW,
  inv07_fLoadPODetail_GETROW,
  fUnitPriceOnChangePO,
} from "../../Server/ApiV2";
import {
  fAlertToast,
  fcovertToNumber,
  fCalculate_Detail,
  GetCostUpdate,
  Get_TransItemStockUOM,
  DBKernUId,
} from "../../Utility/Utilitys";

import {
  Set_HeadObject_DrCrAccount,
  Set_HeadObject_Set,
  Set_HeadObject_A_PayMode,
  Set_HeadObject_DiscFlag,
  Set_HeadObject_SalesGroup_A_Buyer_Set,
} from "./SlicePurchaseOrder";

import {
  vRdxUserInfo,
  KernCAConfig,
  vRdxtax,
  PurchaseOrderRo,
} from "../../Redux/roStore";
import moment from "moment";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { fcheck_null_undefine_replace_empty } from "../../Utility/Utilitys";
import { Set_HeadObject_A_VocNo } from "../PurchaseOrder/SlicePurchaseOrder";

// const { tax1, tax2 } = vRdxtax();
// const vRdxUserInfoObj = vRdxUserInfo();
// const { HeadObject } = PurchaseOrderRo();

export const BatchDetail_ErrorMsg_Init = {
  BatchDetail_SrNo: "",
  BatchDetail_BatchNo: "",
  BatchDetail_MFDate: "",
  BatchDetail_ExpDate: "",
  BatchDetail_Qty: "",
  BatchDetail_Unit: "",
  BatchDetail_PackQty: "",
  BatchDetail_BaseQty: "",
};
export const ErrorMsg = {
  A_VocTyp: "",
  A_VocNo: "",
  A_PostDt: "",
  A_RefDocVer: "",
  A_RefDocNo: "",
  A_RefDocTyp: "",
  A_RefDocTypName: "",
  A_RefNo: "",
  A_RefDt: "",
  Type: "",
  A_PayMode: "",
  UnloadingBay: "",
  A_Party: "",
  A_PartyName: "",
  VendorInvAmount: "",
  A_Curr: "",
  A_ExRate: "",
  A_Loc: "",
  TaxType: "",
  PurchaseReturnType: "",
  offer: "",
  A_CrAc: "",
  A_CrAcName: "",
  A_DrAc: "",
  A_DrAcName: "",
  A_Type: "",
  A_Rounding: "",
  A_DiscFlag: "",
  A_LC: "",
  A_Charges1: "",
  A_DocStat: "",
  A_AutoBatch: "",
  xErrorMsg: "",
  virtualBin: "",
  A_Buyer: "",
  Rebate: "",
  RCM: "",
  Weighing: "",
  Tax: "",
  TaxGross: "",
  A_Narr: "",
  Department: "",
  salesGroup: "",
  PoTerms: "",
};
export const ErrorMsgDetail = {
  B_Srno: "",
  B_Itmcd: "",
  B_Barcode: "",
  B_ItmName: "",
  B_Qty: "",
  B_Unit: "",
  B_PackQty: "",
  SplDisc: "",
  B_URateFc: "",
  B_URateLc: "",
  B_GrossAmt: "",
  B_TDiscPerc: "",
  B_TDiscAmt: "",
  B_LDiscPerc: "",
  B_LDiscAmt: "",
  B_FocFlag: "",
  B_AprmtFlag: "",
  B_FocAmt: "",
  B_ExciseTaxAmt: "",
  B_ExciseTaxNetAmt: "",
  SplDiscAmt: "",
  B_Base_Rate: "",
  B_TaxDept: "",
  B_TaxPerc: "",
  B_TaxAmt: "",
  B_TaxDept2: "",
  B_TaxPerc2: "",
  B_TaxAmt2: "",
  B_NetAddCess: "",
  RebateType: "",
  ReduceCost: "",
  ExpDate: "",
  HC: "",
  PR: "",
  SplDiscPerc: "",
  B_NetAmt: "",
  B_IncGroup: "",
  B_SuprvPerc: "",
  B_OthersPerc: "",
  B_SLANSuprv: "",
  B_SlabAmtSuprv: "",
  B_SLANOther: "",
  B_SlabAmtOther: "",
};
export const vHeaderSearchInit = {
  AnyData: "",
  Name: "",
  Code: "",
};

export const sTrnTyp = "INV02";

const sFocFlagArr = [
  "",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "AA",
  "AB",
  "AC",
  "AD",
  "AE",
  "AF",
  "AG",
  "AH",
  "AJ",
  "AK",
  "AL",
  "AM",
  "AN",
  "AO",
  "AP",
  "AQ",
  "AR",
  "AS",
  "AT",
  "AU",
  "AV",
  "AW",
  "AX",
  "AY",
  "AZ",
  "BA",
  "BB",
  "BC",
  "BD",
  "BE",
  "BF",
  "BG",
  "BH",
  "BJ",
  "BK",
  "BL",
  "BM",
  "BN",
  "BO",
  "BP",
  "BQ",
  "BR",
  "BS",
  "BT",
  "BU",
  "BV",
  "BW",
  "BX",
  "BY",
  "BZ",
  "CA",
  "CB",
  "CC",
  "CD",
  "CE",
  "CF",
  "CG",
  "CH",
  "CJ",
  "CK",
  "CL",
  "CM",
  "CN",
  "CO",
  "CP",
  "CQ",
  "CR",
  "CS",
  "CT",
  "CU",
  "CV",
  "CW",
  "CX",
  "CY",
  "CZ",
  "DA",
  "DB",
  "DC",
  "DD",
  "DE",
  "DF",
  "DG",
  "DH",
  "DJ",
  "DK",
  "DL",
  "DM",
  "DN",
  "DO",
  "DP",
  "DQ",
  "DR",
  "DS",
  "DT",
  "DU",
  "DV",
  "DW",
  "DX",
  "DY",
  "DZ",
];
export const sLoadedCostAccountArr = ["Vendor", "G.L A/c"];
export const sLoadedCostToggleData = ["Any", "Code", "Name"];

export const Loaded_Cost_Freight_Init = {
  Loaded_Cost_Freight_Acc: "",
  Loaded_Cost_Freight_Code: "",
  Loaded_Cost_Freight_Name: "",
  Loaded_Cost_Customs_Acc: "",
  Loaded_Cost_Customs_Code: "",
  Loaded_Cost_Customs_Name: "",
  Loaded_Cost_Discount_Code: "",
  Loaded_Cost_Discount_Name: "",
  Loaded_Cost_SplDiscount_Code: "",
  Loaded_Cost_SplDiscount_Name: "",
};
export const ItemSearchData = [
  "Any",
  "Code",
  "Barcode",
  "Name",
  "RefNo",
  "NameFL",
];

export const locatonSearchData = ["Any", "Code", "Name"];
const sFrom = [
  { Uid: "VENDOR_INV", Name: "Vendor" },
  { Uid: "TRANSFER_RETURN", Name: "Outlet" },
  { Uid: "SALES_RETURN", Name: "Sales Return" },
];

const sPaymode = [
  { Uid: "CASH", Name: "Cash" },
  { Uid: "CREDIT", Name: "Credit" },
];

const sTax = [
  { Uid: "INTRN001", Name: "VAT" },
  { Uid: "INTRN002", Name: "Inter.Comp" },
  { Uid: "INTRN003", Name: "Import" },
];

const TypeArr = [
  { Uid: "", Name: "" },
  { Uid: "Linewise Rebate", Name: "Linewise Rebate" },
  { Uid: "Credit Note", Name: "Credit Note" },
];
export const sStatusArr = ["ENTER", "POST", "DELETE", "DRAFT", "CANCEL"];

export const xGC_Toggle_Head_Customer_DropDown_Arr = ["Any", "Code", "Name"];
//GCcustomer end
const fKey = (event) => {
  // PurchaseOrderContent
  const form = document.getElementById("Head");
  const index = [...form].indexOf(event.target);
  if (index < form.length - 1) {
    if (event.key === "Enter") {
      form.elements[index + 1]?.focus();
    }
  }
};
export const UnitRateFlag = () => {
  const { DBKernObj } = KernCAConfig();
  const iShowField = DBKernObj.WMINV03_UNITRATE_VLDT?.Val === "N";
  if (iShowField) {
    return false;
  } else {
    return true;
  }
};

const fKeyContent = (event) => {
  // PurchaseOrderContent
  const form = document.getElementById("PurchaseOrderContent");
  const index = [...form].indexOf(event.target);
  if (index < form.length - 1) {
    if (event.key === "Enter") {
      form.elements[index + 1]?.focus();
    }
  }
};

export const GetPengingPo = async (
  xVocNo,
  xVocTyp,
  setGridDataAccountDetailRows
) => {
  var vObj = {
    v_PO_VocTyp: xVocTyp,
    v_PO_VocNo: xVocNo,
  };
  const iAccountPostingDetail = await WmsInbound_getPendingPo_API(vObj);
  if (iAccountPostingDetail?.status === 200) {
    setGridDataAccountDetailRows(iAccountPostingDetail?.data?.ResultSet);
    console.log(iAccountPostingDetail?.data?.ResultSet);
    return iAccountPostingDetail?.data?.ResultSet;
  }
};
export const GetPallet = async (xVocNo, xVocTyp, setPalletData) => {
  var vObj = {
    v_PO_VocTyp: xVocTyp,
    v_PO_VocNo: xVocNo,
  };
  const resp = await WmsInbound_getPallet_API(vObj);
  if (resp?.status === 200) {
    setPalletData(resp?.data?.ResultSet);
    console.log(resp?.data?.ResultSet);
    return resp?.data?.ResultSet;
  } else {
    setPalletData([]);
  }
};
const fValidationHead_Client = (
  vRdxHead,
  setErrorMsg,
  sFooterObj,
  vMediaQuery,
  fSummary,
  vRdxDBKernObj
) => {
  let iRes = true;

  if (
    vRdxHead.A_VocTyp === "" ||
    vRdxHead.A_VocTyp === null ||
    vRdxHead.A_VocTyp === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_VocTyp: "VocTyp should not be empty",
    }));
    fAlertToast("INFO", "VocTyp should not be empty");
    iRes = false;
  } //new validation

  if (
    vRdxHead.A_VocNo === "" ||
    vRdxHead.A_VocNo === null ||
    vRdxHead.A_VocNo === undefined
  ) {
    setErrorMsg((obj) => ({ ...obj, A_VocNo: "VocNo should not be empty" }));
    fAlertToast("INFO", "VocNo should not be empty");
    iRes = false;
  }

  if (
    (vRdxHead.PoTerms === "" ||
      vRdxHead.PoTerms === null ||
      vRdxHead.PoTerms === undefined) &&
    DBKernUId("INV02_PAYTERMS_VISIBLE")
  ) {
    setErrorMsg((obj) => ({ ...obj, PoTerms: "Po.Terms should not be empty" }));
    fAlertToast("INFO", "Po.Terms should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_PostDt === "" ||
    vRdxHead.A_PostDt === null ||
    vRdxHead.A_PostDt === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_PostDt: "PostDt should not be empty",
    }));
    fAlertToast("INFO", "PostDt should not be empty");
    iRes = false;
  }

  if (sFooterObj.A_LandVal < 0) {
    setErrorMsg((obj) => ({
      ...obj,
      A_Rounding: "Transaction amount should be greater than zero",
    }));
    fAlertToast("INFO", "Transaction amount should be greater than zero");
    iRes = false;
  }

  if (
    vRdxHead.A_RefDt === "" ||
    vRdxHead.A_RefDt === null ||
    vRdxHead.A_RefDt === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_RefDt: "Reference Date should not be Empty",
    }));
    fAlertToast("INFO", "Reference Date should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.A_Party === "" ||
    vRdxHead.A_Party === null ||
    vRdxHead.A_Party === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_PartyName: "Party should not be empty",
    }));
    fAlertToast("INFO", "Party should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_PartyName === "" ||
    vRdxHead.A_PartyName === null ||
    vRdxHead.A_PartyName === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_PartyName: "Party Name should not be empty",
    }));
    fAlertToast("INFO", "Party Name should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.VendorInvAmount === "" ||
    vRdxHead.VendorInvAmount === null ||
    vRdxHead.VendorInvAmount === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      VendorInvAmount: "Vendor Inv.Amt should not be empty",
    }));
    fAlertToast("INFO", "Vendor Inv.Amt should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.Type === "" ||
    vRdxHead.Type === null ||
    vRdxHead.Type === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      Type: "Type should not be empty",
    }));
    fAlertToast("INFO", "Type should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_Curr === "" ||
    vRdxHead.A_Curr === null ||
    vRdxHead.A_Curr === undefined
  ) {
    if (vMediaQuery) {
      fSummary();
    }
    setErrorMsg((obj) => ({ ...obj, A_Curr: "Curr should not be empty" }));
    fAlertToast("INFO", "Curr should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_ExRate === "" ||
    Number(vRdxHead.A_ExRate) === 0 ||
    vRdxHead.A_ExRate === null ||
    vRdxHead.A_ExRate === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_ExRate: "ExRate should not be empty",
    }));
    fAlertToast("INFO", "ExRate should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_PayMode === "" ||
    vRdxHead.A_PayMode === null ||
    vRdxHead.A_PayMode === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_PayMode: "PayMode should not be Empty",
    }));
    fAlertToast("INFO", "PayMode should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.A_Loc === "" ||
    vRdxHead.A_Loc === null ||
    vRdxHead.A_Loc === undefined
  ) {
    setErrorMsg((obj) => ({ ...obj, A_Loc: "Location should not be Empty" }));
    fAlertToast("INFO", "Location should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.TaxType === "" ||
    vRdxHead.TaxType === null ||
    vRdxHead.TaxType === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      TaxType: "Tax Type should not be Empty",
    }));
    fAlertToast("INFO", "Tax Type should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.A_Buyer === "" ||
    vRdxHead.A_Buyer === null ||
    vRdxHead.A_Buyer === undefined
  ) {
    if (vMediaQuery) {
      fSummary();
    }
    setErrorMsg((obj) => ({
      ...obj,
      A_Buyer: "A_Buyer should not be Empty",
    }));
    fAlertToast("INFO", "A_Buyer should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.Division === "" ||
    vRdxHead.Division === null ||
    vRdxHead.Division === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      Division: "Division should not be Empty",
    }));
    fAlertToast("INFO", "Division should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.Tax === "" ||
    vRdxHead.Tax === null ||
    vRdxHead.Tax === undefined
  ) {
    setErrorMsg((obj) => ({ ...obj, Tax: "Tax should not be Empty" }));
    fAlertToast("INFO", "Tax should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.TaxGross === "" ||
    vRdxHead.TaxGross === null ||
    vRdxHead.TaxGross === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      TaxGross: "TaxGross should not be Empty",
    }));
    fAlertToast("INFO", "TaxGross should not be Empty");
    iRes = false;
  }

  return iRes;
};

const fValidationDetail_Client = (sBufferObj, setErrorMsgDetail) => {
  const { DBKernObj } = KernCAConfig();

  let iRes = true;

  if (sBufferObj.B_Srno === "") {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Srno: "Serial number should not be empty",
    }));
    fAlertToast("INFO", "Serial number should not be empty");
    iRes = false;
  }

  if (sBufferObj.B_Itmcd === "") {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Itmcd: "Item code should not be empty",
    }));
    fAlertToast("INFO", "Item code should not be empty");
    iRes = false;
  }

  if (sBufferObj.B_ItmName === "") {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_ItmName: "Item name should not be empty",
    }));
    fAlertToast("INFO", "Item name should not be empty");
    iRes = false;
  }

  if (sBufferObj.B_Qty === "" || Number(sBufferObj.B_Qty) <= 0) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Qty:
        Number(sBufferObj.B_Qty) <= 0
          ? "Negative quantity not allowed"
          : "Quantity should not be zero",
    }));
    fAlertToast("INFO", "Quantity should not be zero or negative");
    iRes = false;
  }

  if (sBufferObj.B_Unit === "") {
    setErrorMsgDetail((obj) => ({ ...obj, B_Unit: "Select unit" }));
    fAlertToast("INFO", "Select unit");
    iRes = false;
  } else if (sBufferObj.B_PackQty === "" || Number(sBufferObj.B_PackQty) <= 0) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_PackQty: "Pack quantity should not be zero",
    }));
    fAlertToast("INFO", "Pack quantity should not be zero");
    iRes = false;
  }

  if (UnitRateFlag()) {
    if (Number(sBufferObj.B_URateFc) <= 0 || sBufferObj.B_URateFc === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_URateFc: "Unit rate[F.C] should not be Zero",
      }));
      fAlertToast("INFO", "Unit rate[F.C] should not be Zero");
      iRes = false;
    }

    if (sBufferObj.B_GrossAmt === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_GrossAmt: "GrossAmt should not be Empty",
      }));
      fAlertToast("INFO", "GrossAmt should not be Empty");
      iRes = false;
    }

    if (sBufferObj.B_TDiscPerc === "" || sBufferObj.B_TDiscAmt === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_TDiscPerc: "TDiscPerc should not be Empty",
      }));
      fAlertToast("INFO", "TDiscPerc should not be Empty");
      iRes = false;
    }

    if (sBufferObj.B_LDiscPerc === "" || sBufferObj.B_LDiscAmt === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_LDiscPerc: "Line discount.% should not be empty",
      }));
      fAlertToast("INFO", "Line discount.% should not be empty");
      iRes = false;
    }

    if (
      (Number(sBufferObj.B_LDiscPerc) <= 0 &&
        Number(sBufferObj.B_LDiscAmt) !== 0) ||
      (Number(sBufferObj.B_LDiscPerc) !== 0 &&
        Number(sBufferObj.B_LDiscAmt) === 0)
    ) {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_LDiscPerc: "Line Disc.% or amount should be Zero",
      }));
      fAlertToast("INFO", "Line Disc.% or amount should be Zero");
      iRes = false;
    } else if (
      Number(sBufferObj.B_LDiscPerc) > 100 ||
      Number(sBufferObj.B_LDiscPerc) < 0
    ) {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_LDiscPerc: "DiscPerc must be between 0 and 100",
      }));
      fAlertToast("INFO", "DiscPerc must be between 0 and 100");
      iRes = false;
    }

    if (sBufferObj.B_FocFlag === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_FocFlag: "FocFlag should not be Empty",
      }));
      fAlertToast("INFO", "FocFlag should not be Empty");
      iRes = false;
    }

    if (sBufferObj.B_FocAmt === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_FocAmt: "FocAmt should not be Empty",
      }));
      fAlertToast("INFO", "FocAmt should not be Empty");
      iRes = false;
    }

    if (sBufferObj.B_ExciseTaxAmt === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_ExciseTaxAmt: "ExciseTaxAmt should not be Empty",
      }));
      fAlertToast("INFO", "ExciseTaxAmt should not be Empty");
      iRes = false;
    }

    if (sBufferObj.B_ExciseTaxNetAmt === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_ExciseTaxNetAmt: "ExciseTaxNetAmt should not be Empty",
      }));
      fAlertToast("INFO", "ExciseTaxNetAmt should not be Empty");
      iRes = false;
    }

    if (sBufferObj.SplDisc === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        SplDisc: "SplDiscAmt should not be Empty",
      }));
      fAlertToast("INFO", "SplDiscAmt should not be Empty");
      iRes = false;
    }

    if (sBufferObj.B_TaxDept === "") {
      setErrorMsgDetail((obj) => ({ ...obj, B_TaxDept: "TaxDept is Empty" }));
      fAlertToast("INFO", "TaxDept is Empty");
      iRes = false;
    }

    if (sBufferObj.B_TaxPerc === "") {
      setErrorMsgDetail((obj) => ({ ...obj, B_TaxPerc: "TaxPerc is Empty" }));
      fAlertToast("INFO", "TaxPerc is Empty");
      iRes = false;
    }

    if (sBufferObj.B_TaxAmt === "") {
      setErrorMsgDetail((obj) => ({ ...obj, B_TaxAmt: "TaxAmt is Empty" }));
      fAlertToast("INFO", "TaxAmt is Empty");
      iRes = false;
    }

    if (sBufferObj.B_TaxDept2 === "") {
      setErrorMsgDetail((obj) => ({ ...obj, B_TaxDept2: "TaxDept2 is Empty" }));
      fAlertToast("INFO", "TaxDept2 is Empty");
      iRes = false;
    }

    if (sBufferObj.B_TaxPerc2 === "") {
      setErrorMsgDetail((obj) => ({ ...obj, B_TaxPerc2: "TaxPerc2 is Empty" }));
      fAlertToast("INFO", "TaxPerc2 is Empty");
      iRes = false;
    }

    if (sBufferObj.B_TaxAmt2 === "") {
      setErrorMsgDetail((obj) => ({ ...obj, B_TaxAmt2: "TaxAmt2 is Empty" }));
      fAlertToast("INFO", "TaxAmt2 is Empty");
      iRes = false;
    }
    if (sBufferObj.B_NetAddCess === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_NetAddCess: "B_NetAddCess is Empty",
      }));
      iRes = false;
    }

    if (sBufferObj.ReduceCost === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        ReduceCost: "Reduce Cost is Empty",
      }));
      iRes = false;
    }

    if (sBufferObj.ExpDate === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        ExpDate: "ExpDate Cost is Empty",
      }));
      iRes = false;
    }

    if (sBufferObj.HC === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        HC: "HC Cost is Empty",
      }));
      iRes = false;
    }

    if (sBufferObj.PR === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        PR: "PR Cost is Empty",
      }));
      iRes = false;
    }

    if (sBufferObj.SplDiscPerc === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        SplDiscPerc: "SplDiscPerc is Empty",
      }));
      iRes = false;
    }

    if (sBufferObj.B_NetAmt === "") {
      setErrorMsgDetail((obj) => ({ ...obj, B_NetAmt: "B_NetAmt is Empty" }));
      fAlertToast("INFO", "B_NetAmt is Empty");
      iRes = false;
    }
  }

  return iRes;
};

const fValidationBatch_Client = (
  sBatchDetailObj,
  setBatchDetailErrorMsg,
  SerialDetalModal
) => {
  let iResp = true;
  // BatchDetail_SrNo: number;
  // BatchDetail_BatchNo: number;
  // BatchDetail_MFDate: Date;
  // BatchDetail_ExpDate: Date;
  // BatchDetail_Qty: number;
  // BatchDetail_Unit: string;
  // BatchDetail_PackQty: number;
  // BatchDetail_BaseQty: number;

  if (sBatchDetailObj.BatchDetail_SrNo === "") {
    setBatchDetailErrorMsg((obj) => ({
      ...obj,
      BatchDetail_SrNo: "Sr.No should not be zero",
    }));
    iResp = false;
  }
  if (sBatchDetailObj.BatchDetail_BatchNo === "") {
    setBatchDetailErrorMsg((obj) => ({
      ...obj,
      BatchDetail_BatchNo:
        SerialDetalModal.Batch == "Y"
          ? "Batch.No should not be zero"
          : "Serial.No should not be zero",
    }));
    iResp = false;
  }
  if (
    (sBatchDetailObj.BatchDetail_BatchNo === "" ||
      sBatchDetailObj.BatchDetail_BatchNo === 0) &&
    SerialDetalModal?.Serial == "Y"
  ) {
    setBatchDetailErrorMsg((obj) => ({
      ...obj,
      BatchDetail_BatchNo:
        sBatchDetailObj.BatchDetail_BatchNo === ""
          ? "Serial.No should not be empty"
          : "Serial.No should not be zero",
    }));
    iResp = false;
  }

  if (sBatchDetailObj.BatchDetail_MFDate === "") {
    setBatchDetailErrorMsg((obj) => ({
      ...obj,
      BatchDetail_MFDate: "MFDate should not be zero",
    }));
    iResp = false;
  }
  if (sBatchDetailObj.BatchDetail_ExpDate === "") {
    setBatchDetailErrorMsg((obj) => ({
      ...obj,
      BatchDetail_ExpDate: "ExpDate should not be zero",
    }));
    iResp = false;
  }
  if (
    sBatchDetailObj.BatchDetail_Qty === "" ||
    sBatchDetailObj.BatchDetail_Qty <= 0
  ) {
    setBatchDetailErrorMsg((obj) => ({
      ...obj,
      BatchDetail_Qty: "Qty should not be zero",
    }));
    iResp = false;
  }
  if (sBatchDetailObj.BatchDetail_Unit === "") {
    setBatchDetailErrorMsg((obj) => ({
      ...obj,
      BatchDetail_Unit: "Unit should not be zero",
    }));
    iResp = false;
  }
  if (sBatchDetailObj.BatchDetail_PackQty === "") {
    setBatchDetailErrorMsg((obj) => ({
      ...obj,
      BatchDetail_PackQty: "PackQty should not be zero",
    }));
    iResp = false;
  }
  if (sBatchDetailObj.BatchDetail_BaseQty === "") {
    setBatchDetailErrorMsg((obj) => ({
      ...obj,
      BatchDetail_BaseQty: "BaseQty should not be zero",
    }));
    iResp = false;
  }
  return iResp;
};
//GCItemSearch
const GetItemSearch = async (
  xValue,
  xVendor,
  setGridSelectRowData,
  setGridSelectRowArr
) => {
  //openCustomer to call api on open modal if value in any data

  let sItemSearch = {
    v_AnyData: xValue,
    v_ItmCd: "",
    v_ItmName: "",
    v_Barcode: "",
    v_ModelSelectedValue: "",
    v_RefNo1: "",
    v_NameFc: "",
    v_CostPr: "",
    v_RSP: "",
    v_Catalogue: "",
    v_Br: "",
    v_RefNo3: "",
    v_Loc: "",
    v_Vendor: xVendor,
  };
  const vItemSearch = await fExecuteAPI("GRN_ITEMSEARCH_GETROW", sItemSearch);
  if (vItemSearch.Status === 200) {
    let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setGridSelectRowArr(vItemSearchArr);
    setGridSelectRowData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch?.Type?.response?.data?.message
        ? vItemSearch?.Type?.response?.data?.message
        : "Error in ItemSearch"
    );
    return [];
  }
};

//TODO FULLSEARCH ,UNITARR ,AND CALCULATION
const fItemCodeDependency = async (
  vItemSearchFull,
  vRdxWmsHead,
  sBufferObj,
  setBufferObj,
  setUnit,
  SetIncentiveGroups,
  setOtherSlabs,
  setSupervisorSlabs,
  sDefZeroTaxCode,
  sDefZeroCessCode,
  setTransItemStockObj
) => {
  const { HeadObject } = PurchaseOrderRo();
  const { DBKernObj } = KernCAConfig();
  const { tax1, tax2 } = vRdxtax();
  if (vItemSearchFull.length > 0) {
    let iTax =
      HeadObject.TaxType == "INTRN002" || HeadObject.TaxType == "INTRN003"
        ? sDefZeroTaxCode
        : vItemSearchFull[0].TaxDept;

    let iCess =
      HeadObject.TaxType == "INTRN002" || HeadObject.TaxType == "INTRN003"
        ? sDefZeroCessCode
        : vItemSearchFull[0].TaxDept2;

    let vRdxGRNtax1arr = tax1?.find((obj) => {
      return obj.UId === iTax;
    });

    let vRdxGRNtax2arr = tax2?.find((obj) => {
      return obj.UId === iCess;
    });

    setBufferObj((obj) => ({
      ...obj,
      B_Itmcd: vItemSearchFull[0].ItmCd,
      B_ItmName: vItemSearchFull[0].Name2,
      B_Barcode: vItemSearchFull[0].BarCode,
      B_TaxDept: vRdxGRNtax1arr?.UId,
      B_TaxDept2: vRdxGRNtax2arr?.UId,
      B_TaxPerc: vRdxGRNtax1arr?.Perc,
      B_TaxPerc2: vRdxGRNtax2arr?.Perc,
      SuppRefNo1: vItemSearchFull[0].SuppRefNo1,
    }));

    let currentUnitArr = await GetUnitArr(vItemSearchFull[0].ItmCd, setUnit);

    let iUnit = vItemSearchFull[0]?.DefUnit || "";

    if (!iUnit) {
      iUnit = vItemSearchFull[0]?.PurUOM || "";
    }

    let vItemUnitSet = currentUnitArr.find((obj) => {
      return obj.Unit === iUnit;
    });

    if (!vItemUnitSet) {
      iUnit = currentUnitArr[0]?.Unit || "";

      vItemUnitSet = currentUnitArr.find((obj) => {
        return obj.Unit === iUnit;
      });
    }

    await Unit_Onchange_001(
      iUnit,
      vItemUnitSet,
      vItemSearchFull[0].ItmCd,
      vRdxGRNtax1arr?.Perc,
      vRdxGRNtax2arr?.Perc,
      setBufferObj,
      setTransItemStockObj,
      sBufferObj
    );

    if (
      vRdxWmsHead.Type == "SALES_RETURN" &&
      DBKernObj?.SONAS_INVOICE?.Val === "Y"
    ) {
      // GetIncentiveGroup
      const vIncentiveGroups = await GetIncentiveGroup(
        vItemSearchFull[0].ItmCd,
        vRdxWmsHead.A_Loc,
        SetIncentiveGroups
      );

      if (vIncentiveGroups.length > 0) {
        setBufferObj((obj) => ({
          ...obj,
          B_IncGroup: vIncentiveGroups[0].UId,
          B_SuprvPerc: vIncentiveGroups[0].SuprvPerc,
          B_OthersPerc: vIncentiveGroups[0].OthersPerc,
        }));
      }
      const vOtherSlabs = await GetOtherSlabs(setOtherSlabs);
      if (vOtherSlabs.length > 0) {
        setBufferObj((obj) => ({
          ...obj,
          B_SLANOther: vOtherSlabs[0],
        }));
      }
      const vSupervisorSlabs = await GetSupervisorSlabs(setSupervisorSlabs);
      if (vSupervisorSlabs.length > 0) {
        setBufferObj((obj) => ({
          ...obj,
          B_SLANSuprv: vSupervisorSlabs[0],
        }));
      }
    }

    document.getElementsByName("B_Qty")[0]?.focus();
  } else {
    fAlertToast("FAILED", "Error in Exact Search");
  }
};
export const Unit_Onchange_001 = async (
  xUnit = "",
  xUnitObj = {},
  xItemCode,
  iTax1Perc,
  iTax2Perc,
  setBufferObj,
  setTransItemStockObj,
  sBufferObj
) => {
  let currentPackQty = "";
  //by sir
  let { HeadObject } = PurchaseOrderRo();
  if (!!xUnitObj) {
    setBufferObj((obj) => ({
      ...obj,
      B_Unit: xUnitObj.Unit,
      B_UnitName: xUnitObj.Name1,
      B_PackQty: xUnitObj.PackQty,
    }));
    currentPackQty = xUnitObj?.PackQty;
  }

  let resp = await GetUnitRate(
    xItemCode,
    xUnit,
    HeadObject?.A_Party,
    HeadObject?.A_Loc,
    HeadObject?.A_RefDocTyp,
    HeadObject?.A_RefDocNo
  );

  let currentUnitRateObj = {
    B_URateFc: 0,
    B_LDiscPerc: 0,
    AddCess: 0,
    SplDiscAmt: 0,
    B_ExciseTaxAmt: 0,
  };

  if (resp?.LastPriceDetails.length > 0) {
    currentUnitRateObj = {
      B_URateFc: resp?.LastPriceDetails[0].CostLc,
      B_LDiscPerc: resp?.LastPriceDetails[0].DiscPerc,
      AddCess: resp?.LastPriceDetails[0].AddiCess,
      SplDisc: resp?.LastPriceDetails[0].SplDiscAmt,
      B_ExciseTaxAmt: resp?.LastPriceDetails[0].ExciseAmt,
    };
    setBufferObj((obj) => ({
      ...obj,
      B_URateFc: resp?.LastPriceDetails[0].CostLc,
      B_LDiscPerc: resp?.LastPriceDetails[0].DiscPerc,
      AddCess: resp?.LastPriceDetails[0].AddiCess,
      SplDisc: resp?.LastPriceDetails[0].SplDiscAmt, //by sir
      B_ExciseTaxAmt: resp?.LastPriceDetails[0].ExciseAmt,
    }));
  }
  if (resp?.UnitChangeDetails.length > 0) {
    setTransItemStockObj({
      RPStock: resp?.UnitChangeDetails[0].Stock,
      MSP: resp?.UnitChangeDetails[0].MSP,
      CostPr: resp?.UnitChangeDetails[0].CostPr,
      LPRate: resp?.UnitChangeDetails[0].LpRate,
    });
  } else {
    setTransItemStockObj({
      RPStock: 0,
      MSP: 0,
      CostPr: 0,
      LPRate: 0,
    });
  }

  let {
    B_BaseQty,
    B_URateLc,
    B_GrossAmt,
    B_LDiscAmt,
    B_TDiscAmt,
    B_FocAmt,
    B_ExciseTaxNetAmt,
    B_NetAmt,
    B_TaxAmt,
    B_TaxAmt2,
    B_Rounding,
    B_NetAddCess,
    B_LandVal,
    SplDiscAmt,
  } = fCalculate_Detail(
    sBufferObj.B_Qty,
    currentPackQty,
    HeadObject.A_ExRate,
    currentUnitRateObj.B_URateFc,
    currentUnitRateObj.B_LDiscPerc,
    sBufferObj.B_TDiscPerc,
    sBufferObj.B_FocFlag,
    currentUnitRateObj.B_ExciseTaxAmt,
    iTax1Perc,
    iTax2Perc,
    currentUnitRateObj.AddCess,
    0,
    sBufferObj.SplDiscPerc
  );
  setBufferObj((obj) => ({
    ...obj,
    B_BaseQty,
    B_URateLc,
    B_GrossAmt,
    B_LDiscAmt,
    B_TDiscAmt,
    B_FocAmt,
    B_ExciseTaxNetAmt,
    B_NetAmt,
    B_TaxAmt,
    B_TaxAmt2,
    B_Rounding,
    B_NetAddCess,
    B_LandVal,
    SplDiscAmt,
  }));
};

const GetSearchItem = async (xData, xType, xA_Loc, setSearchGridData) => {
  const { HeadObject } = PurchaseOrderRo();

  let vSeatchVendor = {
    Data: xData,
    Type: xType,
    Loc: xA_Loc,
    v_Vendor: HeadObject.A_Party || "",
  };
  const vItemSearch = await fExecuteAPI("SEARCHITEM001_GETROW", vSeatchVendor);
  if (vItemSearch?.Type?.toUpperCase() == "SUCCESS") {
    let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setSearchGridData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch.response.data.message
        ? vItemSearch.response.data.message
        : "Error in SearchItem"
    );
  }
};

const fLoad_Grid = async (
  xB_VocNo,
  xB_Srno,
  xRoundingValue = "",
  setDetailGridData,
  setFooterObj,
  xVocTyp
) => {
  const iSIDetail = await GetSIDetail(xB_VocNo, xB_Srno, xVocTyp);
  if (iSIDetail.length > 0) {
    let GridID =
      iSIDetail.length == 0
        ? []
        : iSIDetail.map((obj, i) => ({
            ...obj,
            id: obj.B_Srno,
          }));
    setDetailGridData(GridID);
    var iGrossAmt = 0,
      iTDiscAmt = 0,
      iLDiscAmt = 0,
      iFocAmt = 0,
      iExciseTaxNetAmt = 0,
      iTaxAmt = 0,
      iTaxAmt2 = 0,
      iAddCess = 0,
      iSplDiscAmt1 = 0;

    for (let i = 0; i < iSIDetail?.length; i++) {
      iGrossAmt += iSIDetail[i].B_GrossAmt;
      iTDiscAmt += iSIDetail[i].B_TDiscAmt;
      iLDiscAmt += iSIDetail[i].B_LDiscAmt;
      iFocAmt += iSIDetail[i].B_FocAmt;
      iExciseTaxNetAmt += iSIDetail[i].B_ExciseTaxNetAmt;
      iTaxAmt += iSIDetail[i].B_TaxAmt;
      iTaxAmt2 += iSIDetail[i].B_TaxAmt2;
      iAddCess += iSIDetail[i].B_Ad_NetCessAmt;
      iSplDiscAmt1 += iSIDetail[i].SplDiscAmt1;
    }

    let iLandVal =
      iGrossAmt -
      iTDiscAmt -
      iLDiscAmt -
      iFocAmt +
      iExciseTaxNetAmt +
      // iTaxAmt +
      // iTaxAmt2 +
      // iAddCess +
      // iSplDiscAmt1 +
      fcovertToNumber(xRoundingValue);

    let netAmtFinal =
      iGrossAmt -
      iTDiscAmt -
      iLDiscAmt -
      iFocAmt +
      iExciseTaxNetAmt +
      iTaxAmt +
      iTaxAmt2 +
      iAddCess +
      // iSplDiscAmt1 +
      fcovertToNumber(xRoundingValue);

    setFooterObj((obj) => ({
      ...obj,
      A_GrossAmt: iGrossAmt.toFixed(2),
      A_TDiscAmt: iTDiscAmt.toFixed(2),
      A_LDiscAmt: iLDiscAmt.toFixed(2),
      A_FocAmt: iFocAmt.toFixed(2),
      A_NetExcise: iExciseTaxNetAmt.toFixed(2),
      A_Tax: iTaxAmt.toFixed(2),
      A_Tax2: iTaxAmt2.toFixed(2),
      A_AddCess: iAddCess.toFixed(2),
      netAmtFinal: netAmtFinal.toFixed(2),
      A_LandVal: iLandVal.toFixed(2),
      A_SplDiscAmt1: iSplDiscAmt1.toFixed(2),
    }));
  } else {
    setDetailGridData([]);
    setFooterObj((obj) => ({
      ...obj,
      A_GrossAmt: 0,
      A_TDiscAmt: 0,
      A_LDiscAmt: 0,
      A_FocAmt: 0,
      A_NetExcise: 0,
      A_Tax: 0,
      A_Tax2: 0,
      A_AddCess: 0,
      A_LandVal: 0,
      A_SplDiscAmt1: 0,
      netAmtFinal: 0,
    }));
  }
};

const fCloseRefDocSearchModal = (
  setRefDocSearchModal,
  fRefDocClearSimpleSearch,
  setRefDocModalArr,
  setRefDocModelObj
) => {
  setRefDocSearchModal(false);
  fRefDocClearSimpleSearch();
  setRefDocModalArr([]);
  setRefDocModelObj({
    AnyData: "",
    Name: "",
    Code: "",
  });
};
const fReset_Linewise_Rebate = (setBufferObj) => {
  setBufferObj((obj) => ({
    ...obj,
    RebateType: "",
    ReduceCost: "N",
    SplDiscPerc: 0,
    SplDiscAmt: 0,
  }));
};

//GCSimpleSearch for Ref Doc Modal
const fRefDocRowClick = async (
  e,
  dispatch,
  vRdxWmsHead,
  setRefDocSearchModal,
  fRefDocClearSimpleSearch,
  setRefDocModalArr,
  setRefDocModelObj,
  setBufferObj
) => {
  dispatch(
    Set_HeadObject_Set({
      ...vRdxWmsHead,
      A_RefDocTyp: e?.row?.VocTyp,
      A_RefDocTypName: e?.row?.VocName,
      A_RefDocNo: e?.row?.VocNo,
      A_Party: e?.row?.Vendor,
      A_PartyName: e?.row?.PartyName,
      Type: e?.row?.Source,
      UnloadingBay: e?.row?.LDPay,
      UnloadingBayName: e?.row?.LDPayName,
      A_PostDt: e?.row?.GRNDate,
      A_RefNo: e?.row?.RefNo,
      A_RefDt: e?.row?.RefDate,
      VendorInvAmount: e?.row?.InvAmt,
      A_RefDocVer: e?.row?.SrNo,
    })
  );
  fReset_Linewise_Rebate(setBufferObj);

  GetDefcustomersetting(
    e?.row?.Vendor,
    vRdxWmsHead.A_Loc,
    e?.row?.Source,
    dispatch
  );
  GetDefaultDrCrAccount(
    vRdxWmsHead.A_VocTyp,
    vRdxWmsHead.A_PayMode,
    e?.row?.Vendor,
    dispatch
  );
  // setRefDocModalArr([]);
  setTimeout(() => {
    document.getElementsByName("B_ItmName")[0]?.focus();
  }, 500);
  fCloseRefDocSearchModal(
    setRefDocSearchModal,
    fRefDocClearSimpleSearch,
    setRefDocModalArr,
    setRefDocModelObj
  );
};

//Reverse Modal
const fCloseReverseTransactionModal = (setReverseTransactionModal) => {
  setReverseTransactionModal(false);
};

const fOpenReverseTransactionModal = (setReverseTransactionModal) => {
  setReverseTransactionModal(true);
};

const fReverse = (fSave, setRevNarr, setReverseTransactionModal) => {
  fCloseReverseTransactionModal(setReverseTransactionModal);
  confirmAlert({
    title: "Reverse",
    message: "Are you sure to Reverse.",
    buttons: [
      {
        className: "alertBtn",
        label: "Yes",
        onClick: () => fSave(),
      },
      {
        className: "alertBtn",
        label: "No",
        onClick: () => setRevNarr(""),
      },
    ],
  });
};

const fDefaultPayload = (xPaymode, dispatch) => {
  let iPaymode = xPaymode == "BOTH" ? "CREDIT" : xPaymode; //by client
  let DefaultPayload = {
    currentPayMode: iPaymode,
    PaymodeEnable: false,
  };
  if (xPaymode == "BOTH") {
    DefaultPayload.PaymodeEnable = false;
  } else {
    DefaultPayload.PaymodeEnable = true;
  }

  dispatch(
    Set_HeadObject_A_PayMode({
      A_PayMode: iPaymode,
    })
  );
  return DefaultPayload;
};
const fDiscFlagDependency = (xType, dispatch) => {
  if (xType != "VENDOR_INV") {
    dispatch(
      Set_HeadObject_DiscFlag({
        A_DiscFlag: "Y",
      })
    );
  }
};

//HEAD LOADING API
// Api

//SALESMAN_GETROW
const GetSalesman = async (dispatch) => {
  const iSalesman = await fExecuteAPI("SALESMAN_GETROW");
  if (iSalesman?.Type?.toUpperCase() === "SUCCESS") {
    return iSalesman.ResultSet.length > 0 ? iSalesman.ResultSet : [];
  } else {
    fAlertToast(
      "FAILED",
      iSalesman.response.data.Status
        ? iSalesman.response.data.Status
        : "Error in Currency"
    );
    return [];
  }
};

//API DEFAULTDRCRACCOUNT_GETROW
const GetDefaultDrCrAccount = async (xVocTyp, xPayMode, xParty, dispatch) => {
  const { HeadObject } = PurchaseOrderRo();
  let vDefaultDrCrAccountObj = {
    process: sTrnTyp,
    voucher: xVocTyp,
    paymode: xPayMode,
    party: xParty,
    Type: HeadObject.Type,
    Loc: HeadObject.A_Loc,
  };
  const vDefaultDrCrAccount = await fExecuteAPI(
    "DEFAULTDRCRACCOUNT_GETROW",
    vDefaultDrCrAccountObj
  );
  if (vDefaultDrCrAccount?.Type?.toUpperCase() === "SUCCESS") {
    if (vDefaultDrCrAccount?.ResultSet?.length > 0) {
      dispatch(
        Set_HeadObject_DrCrAccount({
          A_CrAc: !!vDefaultDrCrAccount.ResultSet[0]?.CrAc
            ? vDefaultDrCrAccount.ResultSet[0]?.CrAc
            : "",
          A_CrAcName: !!vDefaultDrCrAccount.ResultSet[0]?.CrAcName
            ? vDefaultDrCrAccount.ResultSet[0]?.CrAcName
            : "",
          A_DrAc: !!vDefaultDrCrAccount.ResultSet[0]?.DrAc
            ? vDefaultDrCrAccount.ResultSet[0]?.DrAc
            : "",
          A_DrAcName: !!vDefaultDrCrAccount.ResultSet[0]?.DrAcName
            ? vDefaultDrCrAccount.ResultSet[0]?.DrAcName
            : "",
        })
      );
    }
  } else {
    fAlertToast("FAILED", vDefaultDrCrAccount.Message);
  }
};

//API GRN_INV02RCVNGSCSEARCH_GETROW
const GetRefDocInbound = async (
  xAnyData,
  xCode,
  xName,
  setHeaderSearchResultArr
) => {
  let vHeaderSearchObj = {
    v_RefDocNo: xAnyData,
    v_InvoiceNo: xCode,
    v_GrnDocNo: xName,
  };
  const vHeaderSearch = await fExecuteAPI(
    "GRN_INV02RCVNGSCSEARCH_GETROW",
    vHeaderSearchObj
  );
  if (vHeaderSearch.Status === 200) {
    let GridID = vHeaderSearch.ResultSet?.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setHeaderSearchResultArr(GridID);
    return GridID;
  } else {
    fAlertToast(
      "FAILED",
      vHeaderSearch.response.data.Status
        ? vHeaderSearch.response.data.Status
        : "Error in loading SrcDoc"
    );
    return [];
  }
};

//API GRN_LOCATIONSEARCH_GETROW
const GetLocation = async (
  xAnyData,
  xCode,
  xName,
  UserID,
  setHeaderSearchResultArr,
  setHeaderSearchResultData
) => {
  let vHeaderSearchObj = {
    v_AnyData: xAnyData,
    v_Cd: xCode,
    v_Distri: "Y",
    v_Name: xName,
    v_UserCd: UserID,
  };
  const vHeaderSearch = await fExecuteAPI(
    "GRN_LOCATIONSEARCH_GETROW",
    vHeaderSearchObj
  );
  if (vHeaderSearch.Status === 200) {
    let GridID = vHeaderSearch.ResultSet?.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setHeaderSearchResultArr(GridID);
    setHeaderSearchResultData(GridID);
    return GridID;
  } else {
    fAlertToast(
      "FAILED",
      vHeaderSearch.response.data.Status
        ? vHeaderSearch.response.data.Status
        : "Error in loading SrcDoc"
    );
    return [];
  }
};

//API Unit GETITEMUNITSINBOUND_GETROW
const GetUnitArr = async (xItemCode, setUnit) => {
  let itemUnitobj = {
    itemCd: xItemCode,
  };
  const UnitInfo = await fExecuteAPI("GETITEMUNITSINBOUND_GETROW", itemUnitobj);
  if (UnitInfo?.Type?.toUpperCase() === "SUCCESS") {
    if (UnitInfo?.ResultSet.length > 0) {
      setUnit(UnitInfo.ResultSet);
      return UnitInfo.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      UnitInfo?.Type?.response?.data?.message
        ? UnitInfo?.Type?.response?.data?.message
        : "Error in UnitArr"
    );
    return [];
  }
};

const GetIncentiveGroup = async (xB_Itmcd, xA_Loc, SetIncentiveGroups) => {
  let vIncentiveGroupsObj = {
    itemCd: xB_Itmcd,
    loc: xA_Loc,
  };
  const vIncentiveGroups = await fExecuteAPI(
    "INCENTIVEGROUP_GETROW",
    vIncentiveGroupsObj
  );
  if (vIncentiveGroups?.Type?.toUpperCase() === "SUCCESS") {
    if (vIncentiveGroups?.ResultSet?.length > 0) {
      SetIncentiveGroups(vIncentiveGroups.ResultSet);
      return vIncentiveGroups.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      vIncentiveGroups?.Type?.response?.data?.message
        ? vIncentiveGroups?.Type?.response?.data?.message
        : "Error in vIncentiveGroups"
    );
    return [];
  }
};
const GetSupervisorSlabs = async (xsetSupervisorSlabs) => {
  const vSupervisorSlabs = await fExecuteAPI("SUPERVISORSLABS_GETROW");
  if (vSupervisorSlabs?.Type?.toUpperCase() === "SUCCESS") {
    xsetSupervisorSlabs(vSupervisorSlabs?.ResultSet);
    return vSupervisorSlabs?.ResultSet;
  } else {
    fAlertToast("FAILED", vSupervisorSlabs?.Message);
    return [];
  }
};

const GetOtherSlabs = async (setOtherSlabs) => {
  const vOtherSlabs = await fExecuteAPI("OTHERSLABS_GETROW");
  if (vOtherSlabs?.Type?.toUpperCase() === "SUCCESS") {
    setOtherSlabs(vOtherSlabs?.ResultSet);
    return vOtherSlabs.ResultSet;
  } else {
    fAlertToast("FAILED", vOtherSlabs.Message);
    return [];
  }
};

//API  ITEM_LINE_GETROW
const GetItemLineArr = async (xItemCode, xLoc, xParty, setItemLine) => {
  let vItemLineObj = {
    v_ItemCd: xItemCode,
    v_Loc: xLoc,
    v_Vendor: xParty,
  };
  const ItemLineInfo = await fExecuteAPI("ITEM_LINE_GETROW", vItemLineObj);
  if (ItemLineInfo?.Status === 200) {
    if (ItemLineInfo.ResultSet.length > 0) {
      setItemLine(ItemLineInfo.ResultSet);
      return ItemLineInfo.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      ItemLineInfo?.Type?.response?.data?.message
        ? ItemLineInfo?.Type?.response?.data?.message
        : "Error in ItemLineArr"
    );
    return [];
  }
};

//API  UNIT_RATE_GETROW
export const GetUnitRate = async (
  xItmCd,
  xUnitId,
  xParty,
  xLoc,
  xVocTyp,
  xVocNo
) => {
  let vUnitRateObj = {
    ItmCd: xItmCd,
    Unit: xUnitId,
    Party: xParty,
    Loc: xLoc,
    VocTyp: xVocTyp,
    VocNo: xVocNo,
  };
  const resp = await fUnitPriceOnChangePO(vUnitRateObj);
  if (resp?.status === 200) {
    if (!!resp.data.ResultSet) {
      return resp?.data?.ResultSet;
    } else {
      return [];
    }
  }
};

//API
const GetItemFullSearchArr = async (xItemName, xLoc) => {
  // let vItemFullSearchDataObj = {
  //   v_AnyData: xItemName,
  //   v_TransType: "F",
  //   v_Report: "Y",
  // };
  let vItemFullSearchDataObj = {
    anyData: xItemName,
    transType: "F",
    report: "Y",
    loc: xLoc,
  };

  const vItemSearchFull = await fExecuteAPI(
    // "ITEM_SEARCHFULL_GETROW",
    "SEARCHEXACTITEM_GETROW",
    vItemFullSearchDataObj
  );
  //status code "" so Success is checked
  if (vItemSearchFull?.Type?.toUpperCase() === "SUCCESS") {
    if (vItemSearchFull?.ResultSet?.length > 0) {
      return vItemSearchFull.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      vItemSearchFull?.Type?.response?.data?.message
        ? vItemSearchFull?.Type?.response?.data?.message
        : "Error in vItemSearchFullArr"
    );
    return [];
  }
};

//API GETSIDETAILS_GETROW
const GetSIDetail = async (xB_VocNo, xB_Srno, xVocTyp) => {
  const { HeadObject } = PurchaseOrderRo();
  let iSIDetailObj = {
    v_VocTyp: HeadObject.A_VocTyp || "",
    v_VocNo: HeadObject.A_VocNo || "",
    v_SrNo: xB_Srno,
    v_TrnTyp: sTrnTyp,
  };

  const resp = await inv02_INV02_LoadDetail_GETROW(iSIDetailObj);
  if (resp?.status === 200) {
    if (resp.data.ResultSet?.length > 0) {
      return resp?.data?.ResultSet;
    } else {
      return [];
    }
  }
};

//API GETITEMATTRIBUTES_GETROW
const fValidateItemsAttributes = async (sBufferObj, setErrorMsgDetail) => {
  const { HeadObject } = PurchaseOrderRo();
  const vRdxUserInfoObj = vRdxUserInfo();
  let vItemAttributesObj = {
    itmCd: sBufferObj.B_Itmcd,
    loc: HeadObject.A_Loc,
    taxType: HeadObject.TaxType,
    unit: sBufferObj.B_Unit,
  };
  const vItemAttributes = await fExecuteAPI(
    "GETITEMATTRIBUTES_GETROW",
    vItemAttributesObj
  );

  if (
    vItemAttributes?.Type?.toUpperCase() === "SUCCESS" &&
    vItemAttributes?.ResultSet?.length > 0
  ) {
    let vGetItemAttributes = vItemAttributes.ResultSet[0];
    let iRes = true;

    if (vGetItemAttributes.Linking != "") {
      setErrorMsgDetail((...obj) => ({
        ...obj,
        B_Itmcd: vGetItemAttributes.Linking,
      }));
      iRes = false;
    }

    if (vGetItemAttributes.ItmActive == "N") {
      setErrorMsgDetail((...obj) => ({
        ...obj,
        B_ItmName: "Item is in-actived",
      }));
      iRes = false;
    }

    // if (vGetItemAttributes.Stock - sBufferObj.B_BaseQty < 0) {
    //     fAlertToast("FAILED", "Qty exceed than Available stock " + vGetItemAttributes.Stock.toFixed(2));
    //     iRes = false
    // }

    if (vGetItemAttributes.TaxDept1 != sBufferObj.B_TaxDept) {
      setErrorMsgDetail((...obj) => ({
        ...obj,
        B_TaxDept: "Tax code is not matching",
      }));
      iRes = false;
    }

    if (vGetItemAttributes.TaxPerc1 != sBufferObj.B_TaxPerc) {
      setErrorMsgDetail((...obj) => ({
        ...obj,
        B_TaxPerc: "Tax % is not matching",
      }));
      iRes = false;
    }

    if (vGetItemAttributes.TaxDept2 != sBufferObj.B_TaxDept2) {
      setErrorMsgDetail((...obj) => ({
        ...obj,
        B_TaxDept2: "Cess code is not matching",
      }));
      iRes = false;
    }

    if (vGetItemAttributes.TaxPerc2 != sBufferObj.B_TaxPerc2) {
      setErrorMsgDetail((...obj) => ({
        ...obj,
        B_TaxPerc2: "Cess % is not matching",
      }));
      iRes = false;
    }

    return { iRes, vGetItemAttributes };
  } else {
    fAlertToast("FAILED", "GETITEMATTRIBUTES_GETROW");
  }
};

//API VALIDATIONDETAILINFO_GETROW
const fGetValidationDetailInfo = async (
  sBufferObj,
  ErrorMsgDetail,
  setErrorMsgDetail
) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  const { HeadObject } = PurchaseOrderRo();
  const { DBKernObj } = KernCAConfig();

  let incentiveGroupAllow = false;
  if (DBKernObj.SONAS_INVOICE) {
    incentiveGroupAllow =
      HeadObject.Type == "SALES_RETURN" && DBKernObj.SONAS_INVOICE?.Val === "Y"
        ? true
        : false;
  }

  let vResp = true;
  let vValidationDetailInfoObj = {
    trnTyp: sTrnTyp,
    vocTyp: HeadObject.A_VocTyp,
    vocNo: HeadObject.A_VocNo,
    B_Srno: sBufferObj.B_Srno,
    userCd: vRdxUserInfoObj.UserID,
    B_Itmcd: sBufferObj.B_Itmcd,
    unit: sBufferObj.B_Unit,
    A_Loc: HeadObject.A_Loc,
    landAmt: sBufferObj.B_LandVal,
    B_Qty: sBufferObj.B_Qty,
    refDoctyp: HeadObject.A_RefDocTyp,
    refDocName: HeadObject.A_RefDocTypName,
    refDocNo: HeadObject.A_RefDocNo,
    party: HeadObject.A_Party,
    B_IncGroup: incentiveGroupAllow ? sBufferObj.B_IncGroup : "N",
    B_BaseQty: sBufferObj.B_BaseQty,
    B_CI: "",
    A_INV_TYPE: "",
  };
  const vValidationDetailInfo = await fExecuteAPI(
    "VALIDATIONDETAILINFO_GETROW",
    vValidationDetailInfoObj
  );
  if (vValidationDetailInfo?.Type?.toUpperCase() == "SUCCESS") {
    vResp = true;
  } else {
    if (vValidationDetailInfo?.Type?.toUpperCase() == "SUCCESS") {
      vResp = true;
    } else if (vValidationDetailInfo?.response?.status == 400) {
      let isKeyAvailable =
        vValidationDetailInfo?.response?.data?.ResultSet?.field in
        ErrorMsgDetail;
      if (isKeyAvailable) {
        setErrorMsgDetail((obj) => ({
          ...obj,
          [vValidationDetailInfo.response.data.ResultSet.field]:
            vValidationDetailInfo.response.data.Status,
        }));
      } else {
        if (vValidationDetailInfo.response.data.Status) {
          fAlertToast("FAILED", vValidationDetailInfo.response.data.Status);
        } else {
          fAlertToast("FAILED", "vValidationDetailInfo.response.data.Status");
        }
      }
      return (vResp = false);
    } else if (vValidationDetailInfo.response.status == 500) {
      fAlertToast("FAILED", vValidationDetailInfo.response.data.Status);
      return (vResp = false);
    }
    return (vResp = false);
  }
  return vResp;
};

//API SaveSIHead
const fSaveHead = async (
  xSave,
  setUser_Doc_Arr,
  sUser_Doc_Arr,
  dispatch,
  fNewDetail,
  sBufferObj,
  fOpenBatchModal,
  setBatchUnit,
  setBatchObj,
  setBatchDetailObj,
  xDocStatus = "POST",
  fNavigateToNotification
) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  const { HeadObject } = PurchaseOrderRo();
  const iStatus = xSave ? HeadObject.A_DocStat : xDocStatus; //xSave False means Post

  let vSaveSIHeadObj = {
    A_VocTyp: HeadObject.A_VocTyp,
    A_VocNo: HeadObject?.A_VocNo,
    A_VocDt: moment(HeadObject.A_PostDt).format("MM/DD/YYYY"),
    A_PostDt: moment(HeadObject.A_PostDt).format("MM/DD/YYYY"),
    A_RefDt: moment(HeadObject.A_RefDt).format("MM/DD/YYYY"),
    A_RefNo: HeadObject.A_RefNo,
    A_Party: HeadObject.A_Party,
    A_Curr: HeadObject.A_Curr,
    A_ExRate: HeadObject.A_ExRate,
    A_PayMode: HeadObject.A_PayMode,
    A_Type: HeadObject.A_Type,
    A_Loc: HeadObject.A_Loc,
    A_Buyer: HeadObject.A_Buyer,
    A_Narr: HeadObject.A_Narr,
    A_CrAc: HeadObject.A_CrAc,
    A_DrAc: HeadObject.A_DrAc,
    A_DiscPerc: HeadObject?.A_DiscPerc,
    A_DiscFlag: HeadObject?.A_DiscFlag,
    A_Rounding: HeadObject?.A_Rounding,
    A_LC: HeadObject.A_LC,
    A_Charges1: HeadObject.A_Charges1,
    A_DocStat: iStatus,
    A_RefNo4: HeadObject.VendorInvAmount,
    IP: vRdxUserInfoObj.IP,
    UserId: vRdxUserInfoObj.UserID,
    A_Taxable: HeadObject.A_Taxable,
    A_CUSTFIELD2:
      HeadObject.Type == "SALES_RETURN" ? HeadObject.salesGroup : "",
    A_CUSTFIELD3: HeadObject.TaxType,
    A_CUSTFIELD4: HeadObject.A_CUSTFIELD4,
    A_CUSTFIELD5: HeadObject.UnloadingBay,
    A_CUSTFIELD6: HeadObject.Type,
    A_CUSTFIELD7: HeadObject.offer,
    A_RefDocTyp: HeadObject.A_RefDocTyp,
    A_RefDocNo: HeadObject.A_RefDocNo,
    A_RefDocVer: HeadObject.A_RefDocVer,
    A_CUSTFIELD9: HeadObject.A_CUSTFIELD9,
    A_AutoBatch: HeadObject.A_AutoBatch, // Y/N
  
    virtualBin: HeadObject?.virtualBin,
    ImportType: '',//new
    // A_LCust: "",
    // A_INV_TYPE: "",
  };
  const vSaveSIHead = await fExecuteAPI(
    "GRN_SAVE_HEAD_GETROW_001",
    vSaveSIHeadObj
  );
  if (vSaveSIHead.Type == "SUCCESS") {
    if (HeadObject.A_VocNo == "0") {
      setUser_Doc_Arr([
        ...sUser_Doc_Arr,
        {
          A_VocTyp: HeadObject.A_VocTyp,
          A_VocNo: vSaveSIHead?.ResultSet[0]?.A_VocNo,
          SrNo: sUser_Doc_Arr.length + 1,
        },
      ]);
    }

    dispatch(
      Set_HeadObject_A_VocNo({
        A_VocNo: xSave
          ? vSaveSIHead?.ResultSet[0]?.A_VocNo
          : HeadObject.A_VocNo,
        A_DocStat: iStatus,
      })
    );

    //approve bool type false
    if (!xSave) {
      fDisplay(
        HeadObject.A_VocTyp,
        xSave ? vSaveSIHead?.ResultSet[0]?.A_VocNo : HeadObject.A_VocNo,
        dispatch,
        fNewDetail
      );
      // WMINV03_CostUpdate_GETROW
      setTimeout(() => {
        GetCostUpdate(sTrnTyp, HeadObject?.A_VocTyp, HeadObject?.A_VocNo);
      }, 200);
      fAlertToast("SUCCESS", "Successfully posted");

      fNavigateToNotification();
    } else {
      fSaveDetail(
        vSaveSIHead.ResultSet[0].A_VocNo,
        sBufferObj,
        fNewDetail,
        fOpenBatchModal,
        setBatchUnit,
        setBatchObj,
        setBatchDetailObj
      );
    }
  }
};

//API GETSIHEAD_GETROW to gethead
const fDisplay = async (
  xA_VocTyp,
  A_VocNo,
  dispatch,
  fNewDetail,
  fBuyreGetRow
) => {
  const { HeadObject } = PurchaseOrderRo();
  let vSIHeadObj = {
    v_A_VocTyp: xA_VocTyp || "",
    v_A_VocNo: A_VocNo || "",
  };
  const resp = await inv02_fINV02_fDisplay_GETROW(vSIHeadObj);

  if (resp?.status === 200) {
    dispatch(
      Set_HeadObject_Set({
        ...HeadObject,
        A_VocTyp: resp?.data?.ResultSet[0].A_VocTyp,
        A_VocTypName: resp?.data?.ResultSet[0].VocName,
        A_VocNo: resp?.data?.ResultSet[0].A_VocNo,
        A_PostDt: resp?.data?.ResultSet[0].A_PostDt,
        A_RefDt: resp?.data?.ResultSet[0].A_RefDt,
        A_RefNo: resp?.data?.ResultSet[0].A_RefNo,
        A_Party: resp?.data?.ResultSet[0].A_Party,
        A_PartyName: resp?.data?.ResultSet[0].PartyName,
        A_Curr: resp?.data?.ResultSet[0].A_Curr,
        A_Currname: resp?.data?.ResultSet[0].CurrName,
        A_ExRate: resp?.data?.ResultSet[0].A_ExRate,
        A_PayMode: resp?.data?.ResultSet[0].A_PayMode,
        Type: resp?.data?.ResultSet[0].A_Type,
        A_Loc: resp?.data?.ResultSet[0].A_Loc,
        A_Buyer: resp?.data?.ResultSet[0].A_Buyer, ////SalesMan
        A_Narr: resp?.data?.ResultSet[0].A_Narr,
        A_DiscPerc: resp?.data?.ResultSet[0].A_DiscPerc
          ? resp?.data?.ResultSet[0].A_DiscPerc
          : 0,
        A_Rounding: resp?.data?.ResultSet[0].A_Rounding
          ? resp?.data?.ResultSet[0].A_Rounding
          : 0,
        A_DocStat: resp?.data?.ResultSet[0].A_DocStat,
        TaxType: resp?.data?.ResultSet[0].A_CUSTFIELD3,
        A_TaxGross: resp?.data?.ResultSet[0].A_TaxGross,
        A_Taxable: resp?.data?.ResultSet[0].A_Taxable,
        A_Br: resp?.data?.ResultSet[0].A_Br, //LocationBrCode
        A_GrossAmt: resp?.data?.ResultSet[0].A_GrossAmt, //decimal
        A_DiscAmt: resp?.data?.ResultSet[0].A_DiscAmt, //decimal
        A_DiscFlag: resp?.data?.ResultSet[0].A_DiscFlag,
        A_TaxAmt: resp?.data?.ResultSet[0].A_TaxAmt, //decimal
        A_NetAmt: resp?.data?.ResultSet[0].A_NetAmt, //decimal

        // VendorInvAmount: resp?.data?.ResultSet[0].A_RefNo4, //INvoice Amount

        Tax:
          resp?.data?.ResultSet[0].A_Taxable == "" ||
          resp?.data?.ResultSet[0].A_Taxable == null
            ? "N"
            : resp?.data?.ResultSet[0].A_Taxable,
        TaxGross:
          resp?.data?.ResultSet[0].A_TaxGross == "" ||
          resp?.data?.ResultSet[0].A_TaxGross == null
            ? "N"
            : resp?.data?.ResultSet[0].A_TaxGross,
        Salesman: "",
        Department: resp?.data?.ResultSet[0].DeptName,
        Division: resp?.data?.ResultSet[0].A_Subvendor,
        salesGroup: resp?.data?.ResultSet[0].A_SalesmanID,
        PoTerms: resp?.data?.ResultSet[0].PoTerms,
        ImportType: '',
      })
    );
    // ItemsAliasListSearch(vSIHead.ResultSet[0].A_Loc, sBufferObj.B_Itmcd);

    fBuyreGetRow(
      resp?.data?.ResultSet[0].A_VocTyp,
      resp?.data?.ResultSet[0].A_VocNo,
      resp?.data?.ResultSet[0].A_Loc
    );

    fNewDetail(
      resp?.data?.ResultSet[0].A_VocNo,
      resp?.data?.ResultSet[0].A_Rounding,
      resp?.data?.ResultSet[0].A_VocTyp,
      resp?.data?.ResultSet[0]?.A_CUSTFIELD3
    );
  }
};

export const MultiCardFlag = () => {
  const { DBKernObj } = KernCAConfig();

  const iShowField = DBKernObj.MULT_CARD_ID?.Val === "Y";
  if (iShowField) {
    return true;
  } else {
    return false;
  }
};
//API SAVESIDETAIL_GETROW
const fSaveDetail = async (
  xB_VocNo,
  sBufferObj,
  fNewDetail,
  fOpenBatchModal,
  setBatchUnit,
  setBatchObj,
  setBatchDetailObj
) => {
  const { HeadObject } = PurchaseOrderRo();
  let vSaveSIDetailObj = {
    B_VocTyp: HeadObject?.A_VocTyp,
    B_VocNo: xB_VocNo,
    B_Srno: sBufferObj.B_Srno,
    B_Itmcd: sBufferObj.B_Itmcd,
    B_Qty: sBufferObj.B_Qty,
    B_Unit: sBufferObj.B_Unit,
    B_URateFc: sBufferObj.B_URateFc,
    B_URateLc: sBufferObj.B_URateLc,
    B_GrossAmt: sBufferObj.B_GrossAmt,
    B_LDiscPerc: sBufferObj.B_LDiscPerc,
    B_LDiscAmt: sBufferObj.B_LDiscAmt,
    B_FocFlag: sBufferObj.B_FocFlag,
    B_AprmtFlag: sBufferObj.B_AprmtFlag,
    B_RefDocTyp: HeadObject.A_RefDocTyp,
    B_RefDocNo: HeadObject.A_RefDocNo,
    B_RefNo2: "",
    B_RefNo3: "",
    B_RefNo5: 0,
    B_ExciseTaxAmt: sBufferObj.B_ExciseTaxAmt,
    B_ExciseTaxNetAmt: sBufferObj.B_ExciseTaxNetAmt,
    B_TaxPerc: sBufferObj.B_TaxPerc,
    B_TaxAmt: sBufferObj.B_TaxAmt,
    SplDiscAmt1: sBufferObj.SplDisc,
    SplDiscAmt2: sBufferObj.SplDiscPerc,
    SplDiscAmt3: sBufferObj.SplDiscAmt,
    Field1: 0,
    Field2: 0,
    Field6: sBufferObj.RebateType,
    Field7: sBufferObj.ReduceCost,
    Field8: sBufferObj?.Narration,
    Field9: "",
    Field10: "",
    B_TaxDept: sBufferObj.B_TaxDept,
    B_TaxDept2: sBufferObj.B_TaxDept2,
    B_TaxPerc2: sBufferObj.B_TaxPerc2,
    B_TaxAmt2: sBufferObj.B_TaxAmt2,
    B_IncGroup: sBufferObj.B_IncGroup,
    B_SuprvPerc: sBufferObj.B_SuprvPerc,
    B_OthersPerc: sBufferObj.B_OthersPerc,
    B_SLANSuprv: sBufferObj.B_SLANSuprv,
    B_SlabAmtSuprv: sBufferObj.B_SlabAmtSuprv,
    B_SLANOther: sBufferObj.B_SLANOther,
    B_SlabAmtOther: sBufferObj.B_SlabAmtOther,
    B_Ad_CessAmt: 0, //by sir
    B_Ad_PCQty: 0, //by sir
    B_Ad_PCRate: sBufferObj.AddCess,
    B_Ad_NetCessAmt: sBufferObj.B_NetAddCess,
    HC: "N",
    PR: "N",
    ExpDate: "",
  };

  const vSaveSIDetail = await fExecuteAPI(
    "GRN_SAVE_DETAIL_GETROW_001",
    vSaveSIDetailObj
  );
  if (vSaveSIDetail.Type?.toUpperCase() === "SUCCESS") {
    fOpenBatchModal(
      vSaveSIDetail.ResultSet[0].B_Srno,
      sBufferObj.B_BaseQty,
      sBufferObj.B_PackQty
    );
    setBatchObj((obj) => ({
      ...obj,
      SrNo: vSaveSIDetail.ResultSet[0].B_Srno,
      ItemCode: sBufferObj.B_Itmcd,
      ItemName: sBufferObj.B_ItmName,
      Qty: sBufferObj.B_Qty,
      Unit: sBufferObj.B_UnitName,
      BaseQty: sBufferObj.B_BaseQty,
    }));
    let vBatchUnit = await GetUnitArr(sBufferObj.B_Itmcd, setBatchUnit);
    setBatchDetailObj((obj) => ({
      ...obj,
      BatchDetail_Unit: sBufferObj.B_Unit,
      BatchDetail_Qty: 0,
      BatchDetail_PackQty: sBufferObj.B_PackQty,
      BatchDetail_BaseQty: 0,
    }));
    fNewDetail(
      xB_VocNo,
      HeadObject.A_Rounding,
      HeadObject?.A_VocTyp,
      HeadObject?.TaxType
    );
    if (vSaveSIDetail.ResultSet[0].isVariComp == "Y") {
      fAlertToast(
        "SUCCESS",
        "You have completed the variance and saved Successfully"
      );
    } else {
      fAlertToast("SUCCESS", "Successfully Saved");
    }
  }
};

//API "GetItemAttributesPurchase_GETROW"
const GetItemAttributesPurchase = async (dispatch, sBufferObj) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  const { HeadObject } = PurchaseOrderRo();
  let vItemAttributesPurchaseObj = {
    itmCd: sBufferObj.B_Itmcd,
    loc: HeadObject.A_Loc,
    taxType: HeadObject.TaxType,
    unit: sBufferObj.B_Unit,
    party: HeadObject.A_Party,
    TrnTyp: sTrnTyp,
    PO_DocTyp: HeadObject.A_RefDocTyp,
    PO_DocNo: HeadObject.A_RefDocNo,
    UserCd: vRdxUserInfoObj.UserID,
    TaxDept1: sBufferObj?.B_TaxDept,
    TaxDept2: sBufferObj?.B_TaxDept2,
  };
  const vItemAttributesPurchase = await fExecuteAPI(
    "GetItemAttributesPurchase_GETROW",
    vItemAttributesPurchaseObj
  );
  if (vItemAttributesPurchase.Type?.toUpperCase() === "SUCCESS") {
    return vItemAttributesPurchase.ResultSet;
  } else {
    fAlertToast("FAILED", vItemAttributesPurchase?.response?.data?.Status);
    return [];
  }
};

//API  "PoQtyValidation_GETROW",
const GetPoQtyValidation = async (
  dispatch,
  xB_Srno,
  xB_Itmcd,
  xB_Qty,
  xB_Unit
) => {
  const { HeadObject } = PurchaseOrderRo();

  let vPoQtyValidationObj = {
    PoTyp: HeadObject.A_RefDocTyp,
    PoNo: HeadObject.A_RefDocNo,
    GrnType: HeadObject.A_VocTyp,
    GrnNo: HeadObject.A_VocNo,
    SrNo: xB_Srno,
    ItmCd: xB_Itmcd,
    Qty: xB_Qty,
    Unit: xB_Unit,
  };

  const vPoQtyValidation = await fExecuteAPI(
    "PoQtyValidation_GETROW",
    vPoQtyValidationObj
  );
  if (vPoQtyValidation.Type?.toUpperCase() === "SUCCESS") {
    return vPoQtyValidation.ResultSet;
  } else {
    fAlertToast("FAILED", vPoQtyValidation?.response?.data?.Status);
    return [];
  }
};
export const SalesReturnLineItem_Validation = async (dispatch, sBufferObj) => {
  const { HeadObject } = PurchaseOrderRo();

  let iRespObj = {
    v_VocTyp: HeadObject.A_VocTyp,
    v_VocNo: HeadObject.A_VocNo,
    v_SrNo: sBufferObj.B_Srno,
    v_RefVocTyp: HeadObject.A_RefDocTyp,
    v_RefVocNo: HeadObject.A_RefDocNo,
    v_RefSrNo: HeadObject.A_RefDocVer,
    v_ItmCd: sBufferObj.B_Itmcd,
    v_Qty: sBufferObj.B_Qty,
    v_Unit: sBufferObj.B_Unit,
  };

  const iResp = await fExecuteAPI("SalesReturnLineItemValidation", iRespObj);
  console.log("asdasfda", iResp);
  if (iResp.Type?.toUpperCase() === "SUCCESS") {
    return true;
  } else {
    fAlertToast(
      "FAILED",
      iResp?.response?.data?.message || "Error in SalesReturnLineItem"
    );
    return false;
  }
};

export const getPODetail = async (
  refDocType = "",
  refDocNo = "",
  voucher = "",
  vocNo = "",
  srNo = "",
  itemCode = "",
  qty = "",
  unit = "",
  set
) => {
  let obj = {
    refDocType: refDocType,
    refDocNo: refDocNo,
    voucher: voucher,
    vocNo: vocNo,
    srNo: srNo,
    itemCode: itemCode,
    qty: qty,
    unit: unit,
  };
  let ApiObj = await inv07_fLoadPODetail_GETROW(obj);
  console.log("inv07_fLoadPODetail_GETROW", ApiObj);

  if (ApiObj?.data?.data) {
    // let { OS, PDCAmt, CrLimit, FixedCost, CrLmtPrd } = ApiObj?.data?.ResultSet[0];
    // let PartyNetOs = OS + PDCAmt;
    let { poQty, poUnit, poBalanceQty, xType, xSpclDiscPerc, xSpclDiscAmt } =
      ApiObj?.data?.data;
    set({
      poQty: poQty,
      poUnit: poUnit,
      poBalanceQty: poBalanceQty,
      xType: xType,
      xSpclDiscPerc: xSpclDiscPerc,
      xSpclDiscAmt: xSpclDiscAmt,
    });
  } else {
    set({
      poQty: "0.00",
      poUnit: "",
      poBalanceQty: "0",
      xType: "",
      xSpclDiscPerc: "0.00",
      xSpclDiscAmt: "0.00",
    });
  }
};
//API  "TsrQtyValidation_GETROW",
const GetTsrQtyValidation = async (
  dispatch,
  xB_Srno,
  xB_Itmcd,
  xB_Qty,
  xB_Unit
) => {
  const { HeadObject } = PurchaseOrderRo();

  let vTsrQtyValidationObj = {
    PoTyp: HeadObject.A_RefDocTyp,
    PoNo: HeadObject.A_RefDocNo,
    GrnType: HeadObject.A_VocTyp,
    GrnNo: HeadObject.A_VocNo,
    SrNo: xB_Srno,
    ItmCd: xB_Itmcd,
    Qty: xB_Qty,
    Unit: xB_Unit,
  };

  const vTsrQtyValidation = await fExecuteAPI(
    "TsrQtyValidation_GETROW",
    vTsrQtyValidationObj
  );

  if (vTsrQtyValidation.Type?.toUpperCase() === "SUCCESS") {
    return vTsrQtyValidation.ResultSet;
  } else {
    fAlertToast("FAILED", vTsrQtyValidation?.response?.data?.Status);
    return [];
  }
};

//API  "GrnRefNoValidation_GETROW",
const GrnRefNoValidation = async (dispatch) => {
  const { HeadObject } = PurchaseOrderRo();
  let vGrnRefNoValidationObj = {
    TrnTyp: sTrnTyp,
    RefNo: HeadObject.A_RefDocNo,
    Vendor: HeadObject.A_Party,
    VocTyp: HeadObject.A_VocTyp,
    VocNo: HeadObject.A_VocNo,
  };
  const vGrnRefNoValidation = await fExecuteAPI(
    "GrnRefNoValidation_GETROW",
    vGrnRefNoValidationObj
  );
  if (vGrnRefNoValidation.Type?.toUpperCase() === "SUCCESS") {
    return vGrnRefNoValidation.ResultSet ? vGrnRefNoValidation.ResultSet : [];
  } else {
    fAlertToast("FAILED", vGrnRefNoValidation?.response?.data?.Status);
    return [];
  }
};

//API TransTaxType_GETROW
const GetTransTaxType = async (xLoc, xParty, dispatch) => {
  let vTransTaxTypeObj = {
    loc: xLoc,
    party: xParty,
    taxtype: "IN",
  };
  const vTransTaxType = await fExecuteAPI(
    "TransTaxType_GETROW",
    vTransTaxTypeObj
  );
  if (vTransTaxType.Type?.toUpperCase() === "SUCCESS") {
    if (vTransTaxType.ResultSet.length > 0) {
      return vTransTaxType.ResultSet[0];
    } else {
      fAlertToast("FAILED", "Default tax object is empty");
      return {};
    }
  } else {
    fAlertToast("FAILED", vTransTaxType?.response?.data?.Status);
    return {};
  }
};

//API SAVE_DETAIL_BATCH_GETROW_001
const GetSaveDetailBatch = async (sBatchObj, sBatchDetailObj, dispatch) => {
  const { HeadObject } = PurchaseOrderRo();
  // BatchDetail_SrNo: number;
  //   BatchDetail_BatchNo: number;
  //   BatchDetail_MFDate: Date;
  //   BatchDetail_ExpDate: Date;
  //   BatchDetail_Qty: number;
  //   : string;
  //   BatchDetail_PackQty: number;
  //   BatchDetail_BaseQty: number;
  let vSaveDetailBatchObj = {
    v_C_VocTyp: HeadObject.A_VocTyp,
    v_C_VocNo: HeadObject.A_VocNo,
    v_C_SrNo: sBatchObj.SrNo,
    v_C_ItmCd: sBatchObj.ItemCode,
    v_C_Qty: sBatchDetailObj.BatchDetail_Qty,
    v_C_Unit: sBatchDetailObj.BatchDetail_Unit,
    v_C_BaseQty: sBatchDetailObj.BatchDetail_BaseQty,
    v_C_Narr: "",
    v_C_BatchNo: sBatchDetailObj.BatchDetail_BatchNo,
    v_C_BatchDt: moment(sBatchDetailObj.BatchDetail_MFDate).format(
      "MM/DD/YYYY"
    ),
    v_C_ExpDt: moment(sBatchDetailObj.BatchDetail_ExpDate).format("MM/DD/YYYY"),
    v_C_PTyp1: "",
    v_C_PTyp2: "",
    v_C_PTyp3: 0,
    v_C_PTyp4: 0,
    v_C_PTyp5: 0,
    v_C_PTyp6: 0,
    v_C_RowID: sBatchDetailObj.BatchDetail_SrNo,
  };
  const resp = await GRNNormal_updateInv03CRow_GETROW(vSaveDetailBatchObj);
  if (resp?.status === 200) {
    fAlertToast("SUCCESS", "Successfully Saved");
    return true;
  } else {
    fAlertToast("FAILED", "Batch not saved");
    return false;
  }
};

//API DELETE_DETAIL_BATCH_GETROW_001
const GetDeleteDetailBatch = async (xSrNo, xRowId, dispatch) => {
  const { HeadObject } = PurchaseOrderRo();
  let vDeleteDetailBatchObj = {
    v_C_VocTyp: HeadObject.A_VocTyp,
    v_C_VocNo: HeadObject.A_VocNo,
    v_C_SrNo: xSrNo,
    v_C_RowID: xRowId,
  };
  const resp = await GRNNormal_deleteInv03CRow_GETROW(vDeleteDetailBatchObj);

  if (resp?.status === 200) {
    console.log(resp);
    fAlertToast("SUCCESS", "Successfully Deleted");
    return true;
  } else {
    fAlertToast("FAILED", "Batch not Deleted");
    return false;
  }
};

//API GET_BATCH_DETAILS_GETROW_001
const GetBatchDetail = async (xSrNo) => {
  const { HeadObject } = PurchaseOrderRo();
  let vBatchDetailObj = {
    v_C_VocTyp: HeadObject?.A_VocTyp,
    v_C_VocNo: HeadObject?.A_VocNo,
    v_C_SrNo: xSrNo,
  };
  const resp = await GRNNormal_Inv03CgetRow_GETROW(vBatchDetailObj);
  if (resp?.status === 200) {
    console.log(resp);
    let respData =
      resp?.data?.ResultSet?.length == 0
        ? []
        : resp?.data?.ResultSet.map((obj, i) => ({
            ...obj,
            id: i + 1,
          }));
    return respData;
  } else {
    return [];
  }
};

//API WMINV03D_GetRow
const Get_Loaded_Cost_WMINV03D_GetRow = async (dispatch) => {
  const { HeadObject } = PurchaseOrderRo();
  let vLoadedCostObj = {
    VocTyp: HeadObject?.A_VocTyp,
    VocNo: HeadObject?.A_VocNo,
  };
  const vLoadedCost = await GRNNormal_INV03D_GetRow_GETROW(vLoadedCostObj);
  if (vLoadedCost?.status === 200) {
    return vLoadedCost?.data?.ResultSet.length > 0
      ? vLoadedCost?.data?.ResultSet
      : [];
  }
};

//API GET_BATCH_DETAILS_GETROW_001
const Get_LoadedCost = async (xData, xType, xAcTyp, xExact, dispatch) => {
  const { HeadObject } = PurchaseOrderRo();
  let vLoaded_Cost_FreightObj = {
    Data: xData,
    Type: xType,
    Loc: HeadObject.A_Loc,
    AcTyp: xAcTyp,
    Exact: xExact,
  };
  const vLandedCostDropdownSearch = await fExecuteAPI(
    "AccountTransSearch_GETROW",
    vLoaded_Cost_FreightObj
  );
  if (vLandedCostDropdownSearch.Type?.toUpperCase() === "SUCCESS") {
    let GridID = [];
    if (vLandedCostDropdownSearch.ResultSet.length > 0) {
      let GridID = vLandedCostDropdownSearch.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      return GridID;
    } else {
      return GridID;
    }
  } else {
    fAlertToast("FAILED", "Error in loading LandedCost Api");
    return [];
  }
};

//API VALIDATE_HEAD_WMINV03_APPROVE_GETROW
const GetValidateHead_Server = async (dispatch, iSplDiscAmt1, xApprove) => {
  const { HeadObject } = PurchaseOrderRo();
  const vRdxUserInfoObj = vRdxUserInfo();
  const { DBKernObj } = KernCAConfig();

  let incentiveGroupAllow = false;
  if (!!DBKernObj.SONAS_INVOICE) {
    incentiveGroupAllow =
      HeadObject.Type == "SALES_RETURN" && DBKernObj.SONAS_INVOICE?.Val == "Y"
        ? true
        : false;
  }

  let vValidateHeadApproveObj = {
    xTrnTyp: sTrnTyp,
    xVocTyp: HeadObject.A_VocTyp,
    xVocNo: HeadObject.A_VocNo,
    xPostDt: moment(HeadObject.A_PostDt).format("MM/DD/YYYY"),
    xLoc: HeadObject.A_Loc,
    xParty: HeadObject.A_Party,
    xUserCd: vRdxUserInfoObj?.UserID,
    xSalesGrp: incentiveGroupAllow ? HeadObject.salesGrp : "",
    xRefDocTyp: HeadObject.A_RefDocTyp,
    xRefDocNo: HeadObject.A_RefDocNo,
    xRefDocName: HeadObject.A_RefDocTypName,
    xRefVer: HeadObject.A_RefDocVer,
    xType: HeadObject.Type,
    xOfferTrans: HeadObject.offer == "Y" ? true : false,
    xUserGrp: vRdxUserInfoObj?.UserGroupCode,
    xRebate: false,
    xBuyer: HeadObject.A_Buyer,
    xSplDiscAmt: 0, //by sir bcoz linerebatand spldisc same
    xFreight: HeadObject.A_LC,
    xCharges: HeadObject.A_Charges1,
    xDiscDistribution: HeadObject.A_DiscFlag == "Y" ? true : false,
    xDrAc: HeadObject.A_CrAc,
    xCrAc: HeadObject.A_DrAc,
    xLineRebatAmount: iSplDiscAmt1,
    xApprove: xApprove,
  };

  const vValidateHeadApprove = await fExecuteAPI(
    "VALIDATE_HEAD_WMINV03_GETROW",
    vValidateHeadApproveObj
  );
  if (vValidateHeadApprove.Type?.toUpperCase() === "SUCCESS") {
    return true;
  } else if (vValidateHeadApprove.Type === "FAILED") {
    fAlertToast(
      "FAILED",
      !!vValidateHeadApprove.Status
        ? vValidateHeadApprove.Status
        : "Error Validate Head Approve"
    );
    return false;
  } else {
    fAlertToast("FAILED", vValidateHeadApprove.response.data.Status);

    return false;
  }
};

//API CHECK_PO_CREDIT_NOTE_AMOUNT_GETROW
const GetCheckPOCreditNoteAmount = async (dispatch) => {
  const { HeadObject } = PurchaseOrderRo();
  let vCheckPOCreditNoteAmountObj = {
    VocTyp: HeadObject?.A_VocTyp,
    VocNo: HeadObject?.A_VocNo,
  };
  const vCheckPOCreditNoteAmount = await fExecuteAPI(
    "CHECK_PO_CREDIT_NOTE_AMOUNT_GETROW",
    vCheckPOCreditNoteAmountObj
  );
  if (vCheckPOCreditNoteAmount.Type?.toUpperCase() === "SUCCESS") {
    return vCheckPOCreditNoteAmount.ResultSet.length > 0
      ? vCheckPOCreditNoteAmount.ResultSet
      : [];
  } else if (vCheckPOCreditNoteAmount.response.status == 400) {
    fAlertToast("FAILED", vCheckPOCreditNoteAmount.response.data.Status);
    return [];
  } else if (vCheckPOCreditNoteAmount.response.status == 500) {
    fAlertToast("FAILED", vCheckPOCreditNoteAmount.response.data.Status);
    return [];
  }
};

//API VALIDATE_COST_VARIANCE_GETROW
const GetValidateCostVariance = async (dispatch) => {
  const { HeadObject } = PurchaseOrderRo();
  const vRdxUserInfoObj = vRdxUserInfo();
  // let vValidateCostVarianceObj = {
  //   voctyp: "WG002",
  //   vocno: "GRSDC00211",
  //   usercd: "001",
  // };
  let vValidateCostVarianceObj = {
    voctyp: HeadObject?.A_VocTyp,
    vocno: HeadObject?.A_VocNo,
    usercd: vRdxUserInfoObj?.UserID,
  };
  const vValidateCostVariance = await fExecuteAPI(
    "VALIDATE_COST_VARIANCE_GETROW",
    vValidateCostVarianceObj
  );
  if (vValidateCostVariance.Type?.toUpperCase() === "SUCCESS") {
    return vValidateCostVariance.ResultSet.length > 0
      ? vValidateCostVariance.ResultSet
      : [];
  } else if (vValidateCostVariance.response.status == 400) {
    fAlertToast("FAILED", vValidateCostVariance.response.data.Status);
    return [];
  } else if (vValidateCostVariance.response.status == 500) {
    fAlertToast("FAILED", vValidateCostVariance.response.data.Status);
    return [];
  }
};

//API SALESGROUP
const GetSalesGroups = async (xA_Loc) => {
  const vSalesGroups = await fExecuteAPI("SALESGROUPS_GETROW", xA_Loc);
  if (vSalesGroups.Type == "SUCCESS") {
    return vSalesGroups.ResultSet;
  } else {
    fAlertToast("FAILED", vSalesGroups.Message);
    return [];
  }
};

var vheaderArrow = 0;
const fRightClick = (e) => {
  vheaderArrow !== 1 ? (vheaderArrow = vheaderArrow + 1) : (vheaderArrow = 1);

  var headerMainTag = document.getElementById(
    "wms-salese-invoice-id"
  ).childNodes;
  for (let index = 0; index < headerMainTag.length; index++) {
    if (vheaderArrow === index) {
      headerMainTag[index].classList.add("main-wms-sales-invoice-show-sm");
    } else {
      headerMainTag[index].classList.remove("main-wms-sales-invoice-show-sm");
    }
  }
};

const fLeftClick = (e) => {
  vheaderArrow !== 0 ? (vheaderArrow = vheaderArrow - 1) : (vheaderArrow = 0);
  var headerMainTag = document.getElementById(
    "wms-salese-invoice-id"
  ).childNodes;
  for (let index = 0; index < headerMainTag.length; index++) {
    if (vheaderArrow === index) {
      headerMainTag[index].classList.add("main-wms-sales-invoice-show-sm");
    } else {
      headerMainTag[index].classList.remove("main-wms-sales-invoice-show-sm");
    }
  }
};

//defcustomersetting_GETROW
const GetDefcustomersetting = async (xAcCd, xLoc, xType, dispatch) => {
  const { DBKernObj } = KernCAConfig();
  const { HeadObject } = PurchaseOrderRo();

  if (DBKernObj.SONAS_INVOICE?.Val === "Y" && xType == "SALES_RETURN") {
    let vdefcustomersettingObj = {
      accd: xAcCd,
      loc: xLoc,
    };
    const vdefcustomersetting = await fExecuteAPI(
      "defcustomersetting_GETROW",
      vdefcustomersettingObj
    );
    if (vdefcustomersetting?.Type?.toUpperCase() == "SUCCESS") {
      if (
        vdefcustomersetting.ResultSet.length > 0 &&
        !!vdefcustomersetting.ResultSet[0].SalesMan
      ) {
        dispatch(
          Set_HeadObject_SalesGroup_A_Buyer_Set({
            A_Buyer: !!vdefcustomersetting.ResultSet[0].SalesMan
              ? vdefcustomersetting.ResultSet[0].SalesMan
              : HeadObject.A_Buyer,
          })
        );
      }
    } else {
      fAlertToast(
        "FAILED",
        !!vdefcustomersetting.Message
          ? vdefcustomersetting.Message
          : "Error in default setting customer"
      );
    }
  }
};

//GC customer
const Get_ToggleDropDown_Load = async (
  xData,
  xType,
  xAcTyp,
  xExact,
  dispatch
) => {
  const { HeadObject } = PurchaseOrderRo();
  let vLoaded_Cost_FreightObj = {
    Data: xData,
    Type: xType,
    Loc: HeadObject.A_Loc,
    AcTyp: xAcTyp,
    Exact: xExact,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vLoaded_Cost_FreightObj);
  const vLandedCostDropdownSearch = await fExecuteAPI(
    "AccountTransSearch_GETROW",
    FinalObj
  );
  if (vLandedCostDropdownSearch.Type?.toUpperCase() === "SUCCESS") {
    let GridID = [];
    if (vLandedCostDropdownSearch.ResultSet.length > 0) {
      let GridID = vLandedCostDropdownSearch.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      return GridID;
    } else {
      return GridID;
    }
  } else {
    fAlertToast("FAILED", "Error in loading LandedCost Api");
    return [];
  }
};
//API GET_BATCH_DETAILS_GETROW_001
const Get_GCSearchBtn = async (xData, xType, xExact = "N") => {
  const vRdxUserInfoObj = vRdxUserInfo();
  let vLoaded_Cost_FreightObj = {
    v_Data: xData,
    v_Type: xType,
    v_TrnTyp: sTrnTyp,
    v_UserId: vRdxUserInfoObj.UserID,
    Exact: xExact,
  };
  const vLandedCostDropdownSearch = await fExecuteAPI(
    "Common_transpartylist_GETROW",
    vLoaded_Cost_FreightObj
  );
  if (vLandedCostDropdownSearch?.Type?.toUpperCase() === "SUCCESS") {
    let GridID = [];
    if (vLandedCostDropdownSearch?.ResultSet?.length > 0) {
      let GridID = vLandedCostDropdownSearch?.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      return GridID;
    } else {
      return GridID;
    }
  } else {
    fAlertToast("FAILED", "Error in loading LandedCost Api");
    return [];
  }
};

const getQtyViewDetails = async (
  dispatch,
  setStockObj,
  xB_Srno,
  xB_Itmcd,
  xB_Qty,
  xB_Unit
) => {
  const { HeadObject } = PurchaseOrderRo();

  if (HeadObject.Type === "VENDOR_INV") {
    let PoQty = await GetPoQtyValidation(
      dispatch,
      xB_Srno,
      xB_Itmcd,
      xB_Qty,
      xB_Unit
    );
    if (PoQty?.length > 0) {
      setStockObj((obj) => ({
        BalanceQty: PoQty[0].BalanceQty,
        POQty: PoQty[0].POQty,
        GRNQty: PoQty[0].GRNQty,
      }));
    }
  } else if (HeadObject.Type === "TRANSFER_RETURN") {
    let tsrQty = await GetTsrQtyValidation(
      dispatch,
      xB_Srno,
      xB_Itmcd,
      xB_Qty,
      xB_Unit
    );
    if (tsrQty?.length > 0) {
      setStockObj((obj) => ({
        BalanceQty: tsrQty[0].BalanceQty,
        POQty: tsrQty[0].TransferQty,
        GRNQty: tsrQty[0].GRNQty,
      }));
    }
  }
};

export const GetAttributes = async (
  setObjectRights,
  setUser_Doc_Arr,
  setDocLoading,
  setCurrency,
  setType,
  setTaxType,
  setLoc,
  setAuduitFields,
  setSalesGroup,
  setDivision,
   setPoTerms,
 
) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  var vObj = {
    userCode: vRdxUserInfoObj.UserID,
    userGroupCode: vRdxUserInfoObj.UserGroupCode,
  };

  const iAttributes = await inv02_fINV02_Attributes_GETROW(vObj);
  if (iAttributes?.status === 200) {
    setUser_Doc_Arr(iAttributes?.data?.ResultSet?.UserDoc);
    setObjectRights(iAttributes?.data?.ResultSet?.Rights);
    setDocLoading(iAttributes?.data?.ResultSet?.DocLoading);
    setCurrency(iAttributes?.data?.ResultSet?.Currency);
    setSalesGroup(iAttributes?.data?.ResultSet?.SalesMan);
    // setDivision(iAttributes?.data?.ResultSet?.Division);
    setType(iAttributes?.data?.ResultSet?.Type);
    setTaxType(iAttributes?.data?.ResultSet?.TaxType);
    setLoc(iAttributes?.data?.ResultSet?.Loc);
    setAuduitFields(iAttributes?.data?.ResultSet?.AuduitFields);
    setPoTerms(iAttributes?.data?.ResultSet?.PayTerms);
    return iAttributes?.data?.ResultSet;
  } else {
    return []; 
  }
};

export const GetMSPUpdate = async (xVocTyp, xVocNo, setGridDataRows) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  var vObj = {
    v_VocTyp: xVocTyp,
    v_VocNo: xVocNo,
    v_TrnTyp: sTrnTyp,
    v_UserCd: vRdxUserInfoObj.UserID,
  };

  const iRespDetail = await WMSIInbound_WMINV03RSPMSPDetail_API(vObj);
  if (iRespDetail?.status === 200 && iRespDetail?.data?.ResultSet.length > 0) {
    let vItemSearchArr = iRespDetail?.data?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
      // MSPGPPerc: fCal_MSPGPPerc(obj.MSP, obj.CostPr),
      // TAXRSP: fCal_TAXRSP(obj.SellPr1, obj.TaxPerc),
      // GPPerc: fCal_GPPerc(obj.SellPr1, obj.CostPr),
    }));
    setGridDataRows(vItemSearchArr);

    return iRespDetail?.data?.ResultSet;
  } else {
    setGridDataRows([]);
    return [];
  }
};

export const fCal_MSPGPPerc = (xMSP, xCostPR) => {
  let MSPGPPerc =
    Number(xMSP) === 0
      ? 0
      : Number(
          (((Number(xMSP) - Number(xCostPR)) / Number(xMSP)) * 100).toFixed(2)
        );
  return MSPGPPerc;
};

export const fCal_TAXRSP = (xSellPr1, xTaxPer) => {
  let iTAXRSP = Number(xSellPr1) + (Number(xSellPr1) * Number(xTaxPer)) / 100;
  return iTAXRSP;
};

export const fCal_GPPerc = (xSellPr1, xCostPR) => {
  let iGPPerc =
    Number(xSellPr1) === 0
      ? 0
      : Number(
          (
            ((Number(xSellPr1) - Number(xCostPR)) / Number(xSellPr1)) *
            100
          ).toFixed(2)
        );
  return iGPPerc;
};
export const fCal_SellPr1 = (xTaxPerc, xTAXRSP) => {
  let SellPr1 =
    Number(xTaxPerc) + 100 === 0
      ? 0
      : (Number(xTAXRSP) * 100) / (Number(xTaxPerc) + 100);
  return SellPr1;
};

export {
  // rows,
  // columns,
  Get_GCSearchBtn,
  fRightClick,
  fLeftClick,
  getQtyViewDetails,
  sPaymode,
  sTax,
  sFrom,
  sFocFlagArr,
  TypeArr,
  fKey,
  fKeyContent,
  // Api
  GetSalesman,
  GetDefaultDrCrAccount,
  GetRefDocInbound,
  GetLocation,
  GetUnitArr,
  GetItemLineArr,
  GetIncentiveGroup,
  GetItemFullSearchArr,
  GetItemSearch,
  fItemCodeDependency,
  GetSearchItem,
  GetTransTaxType,
  GrnRefNoValidation,
  GetItemAttributesPurchase,
  GetPoQtyValidation,
  GetTsrQtyValidation,
  GetSalesGroups,
  GetOtherSlabs,
  GetSupervisorSlabs,
  //save
  fValidationHead_Client,
  fValidationDetail_Client,
  fLoad_Grid,
  fValidateItemsAttributes,
  fGetValidationDetailInfo,
  fSaveHead,
  fSaveDetail,
  fDisplay,

  //refdocmodal
  fRefDocRowClick,
  fCloseRefDocSearchModal,

  //reverse
  fCloseReverseTransactionModal,
  fOpenReverseTransactionModal,
  fReverse,

  //Head functions
  fDefaultPayload,
  fDiscFlagDependency,
  //Batch
  fValidationBatch_Client,
  GetSaveDetailBatch,
  GetDeleteDetailBatch,
  GetBatchDetail,

  //Approve
  GetValidateHead_Server,
  GetCheckPOCreditNoteAmount,
  GetValidateCostVariance,

  //src doc
  fReset_Linewise_Rebate,
  //GCLoadedCost
  Get_LoadedCost,
  Get_Loaded_Cost_WMINV03D_GetRow,
  GetDefcustomersetting,
  //GCCustomer
  Get_ToggleDropDown_Load,
};
